module.exports = "/cyber/_next/static/images/top10-ea187e671804acb54dedf2a68bddc343.jpg";